import React from "react";

import * as echarts from "echarts";
import format from "date-fns/format";

import moment from "moment";

export default class SparkChart extends React.Component {
    state = {
        sites: [],
        staticRating: null,
        height: "100%",
        width: "100%",
    };

    chart = null;
    thisIndex = Math.random() * 10000000;
    callInterval = null;
    chartConfig = "";

    constructor(props) {
        super(props);
        this.handleResize = this.handleResize.bind(this);
    }

    handleResize() {
        this.updateDimensions();
    }

    componentDidMount() {
        this.createChartConfig();
    }

    componentDidUpdate(prevProps) {
        let { lineType } = this.props;

        if (prevProps.lineType !== lineType) {
            if (lineType === "log") {
                this.chart.setOption({
                    yAxis: {
                        type: lineType,
                        min: 0.1,
                        max: 10000,
                    },
                });
            } else {
                this.chart.setOption({
                    yAxis: {
                        type: lineType,
                        min: "dataMin",
                        max: "dataMax",
                    },
                });
            }
        }
    }

    createChartConfig() {
        let { device, field } = this.props;

        this.chart = echarts.init(document.getElementById("main_" + this.thisIndex));

        let seriesName = "Count";

        if (field) {
            if (field === "delta") {
                seriesName = "Minutes";
            } else if (field === "VBatt") {
                seriesName = "Volts";
            }
        }

        let series = {
            name: seriesName,
            type: "line",
            color: "#004C83",
            animation: false,
            symbol: "circle",
            symbolSize: 2,
            connectNulls: true,
        };

        this.createChart(device, series);
        this.attachResizeHandlers();
    }

    createChart(data, series) {
        if (data?.length) {
            let minValue = Number.POSITIVE_INFINITY;

            let values = data.map((value) => {
                let dttm = value.dttm ?? value.received_timestamp;
                let dt = echarts.time.format("yyyy-MM-dd hh:mm:ss", dttm, true);

                let field = this.props.field;
                let valueField = value[field];

                let dataValue = valueField;

                if (field) {
                    if (field === "delta") {
                        dataValue = valueField?.minutes;
                    } else if (field === "VBatt") {
                        let body = value.message_body;
                        let messageValue = body?.state?.reported ?? body?.State?.reported;

                        dataValue = messageValue.Housekeeping?.[field] || messageValue.Vmon?.[field];
                    }
                }

                if (dataValue < minValue) minValue = dataValue;

                return {
                    name: dttm,
                    value: [dt, dataValue],
                };
            });

            let showAxis = this.props.chartType !== "dashboard";
            let leftPadding = this.props.chartType === "dashboard" ? "0%" : "3%";
            let rightPadding = this.props.chartType === "dashboard" ? 0 : 10;

            let options = {
                title: {},
                useUTC: true,
                tooltip: {
                    confine: false,
                    trigger: "axis",
                    axisPointer: {
                        animation: false,
                        type: "line",
                    },
                    position: function (pos, _, __, ___, size) {
                        let topPos = pos[1] - size.contentSize[1] / 2;
                        let leftPos = pos[0] + 50;

                        if (leftPos + 250 > size.viewSize[0]) {
                            leftPos = pos[0] - 200;
                        }

                        const obj = { top: topPos, left: leftPos };

                        return obj;
                    },
                    formatter: function (params) {
                        params = params[0];

                        if (params && params.value && params.value[1] == null) {
                            return "";
                        }

                        const date = params.value[0];
                        let formattedDate = moment(date).format("MM/DD HH:mm");

                        return `<div>${formattedDate} GMT+0</div> <div>${params.marker} ${params.seriesName} : ${params.value[1]}</div>`;
                    },
                },
                grid: {
                    left: leftPadding,
                    top: 40,
                    right: rightPadding,
                    bottom: "20%",
                    containLabel: true,
                },
                xAxis: {
                    type: "time",
                    axisLabel: {
                        formatter: function (date) {
                            let formattedDate = format(date, "MM/dd HH:mm aaa");
                            return formattedDate;
                        },
                        showMaxLabel: false,
                    },
                    splitNumber: 3,
                    show: showAxis,
                },
                yAxis: {
                    type: "value",
                    min: minValue,
                    max: "dataMax",
                    show: showAxis,
                },

                series: [{ ...series, data: values }],
            };

            if (this.props.chartConfig) {
                options = { ...options, ...this.props.chartConfig };
            }

            this.chart.setOption(options);
        }
    }

    attachResizeHandlers() {
        window.addEventListener("resize", this.handleResize);
    }

    updateDimensions() {
        if (this.chart) {
            this.chart.resize();
        }
        let width = this.chart.getWidth();

        this.chart.setOption({
            xAxis: {
                splitNumber: Math.max(1, Math.floor(width / 100) - 2),
            },
        });
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
        if (this.chart) {
            this.chart.dispose();
        }
    }

    render() {
        return (
            <div
                id={`main_${this.thisIndex}`}
                style={{
                    width: this.props.width || this.state.width,
                    margin: "auto",
                    height: this.props.height || this.state.height,
                }}
            ></div>
        );
    }
}
